var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:['overlay', _vm.overlayClass]},[_c('div',{staticClass:"modal"},[(_vm.isActive)?_c(_vm.componentName,_vm._b({tag:"component"},'component',_vm.data,false)):_vm._e()],1)])}
var staticRenderFns = []
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-44fcb75e","hasScoped":true,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./node_modules/vue-svg-inline-loader/dist/index.min.js??ref--6!./src/components/partials/ModalOverlay.vue
// module id = null
// module chunks = 